import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Bot, ArrowRight, Car } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const MobileStickyBar = () => {
  const { language } = useLanguage();
  const { pathname } = useLocation();
  const onVehicle = /^\/nos-vehicules\/[^/]+$/.test(pathname);
  const applyCls = 'flex flex-col items-center justify-center gap-1 bg-yellow-500 text-gray-900 rounded-xl py-2.5 active:scale-95 transition-transform';

  const openChat = () => {
    window.dispatchEvent(new CustomEvent('open-chat-widget'));
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-testid="mobile-sticky-bar">
      <div className="bg-white border-t-2 border-[#1a5c3b] shadow-[0_-4px_20px_rgba(0,0,0,0.15)] px-2 py-2 safe-area-bottom">
        <div className="grid grid-cols-3 gap-1.5">
          <a
            href="tel:5144183968"
            className="flex flex-col items-center justify-center gap-1 bg-[#1a5c3b] text-white rounded-xl py-2.5 active:scale-95 transition-transform"
            data-testid="mobile-bar-call"
          >
            <Phone className="w-5 h-5" />
            <span className="text-[10px] font-bold">{language === 'en' ? 'Call' : 'Appeler'}</span>
          </a>
          <button
            onClick={openChat}
            className="flex flex-col items-center justify-center gap-1 bg-gray-900 text-white rounded-xl py-2.5 active:scale-95 transition-transform"
            data-testid="mobile-bar-chat"
          >
            <Bot className="w-5 h-5" />
            <span className="text-[10px] font-bold">Chat</span>
          </button>
          {onVehicle ? (
            <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('open-quick-apply'))} className={applyCls} data-testid="mobile-bar-finance-me">
              <Car className="w-5 h-5" />
              <span className="text-[10px] font-bold">{language === 'en' ? 'Finance Me!' : 'Financez-moi!'}</span>
            </button>
          ) : (
            <Link to="/verifier-admissibilite" className={applyCls} data-testid="mobile-bar-apply">
              <ArrowRight className="w-5 h-5" />
              <span className="text-[10px] font-bold">{language === 'en' ? 'Apply' : 'Appliquer'}</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileStickyBar;
